/** Display metadata keyed by pointsCost (1 NOSMEN box = 1 point). */
export const REWARD_DISPLAY_BY_POINTS = {
  1: {
    image: 'image/gift-1.png',
    quantityLabel: 'จำนวน 1 ชิ้น',
  },
  2: {
    image: 'image/gift-2.png',
    quantityLabel: 'จำนวน 1 ชิ้น',
  },
  3: {
    image: 'image/gift-3.png',
    quantityLabel: 'จำนวน 1 ใบ',
  },
  4: {
    image: 'image/gift-4.png',
    quantityLabel: 'จำนวน 1 ชิ้น',
  },
  5: {
    image: 'image/gift-5.png',
    quantityLabel: 'จำนวน 1 ชิ้น',
  },
  6: {
    image: 'image/gift-6.png',
    quantityLabel: 'จำนวน 1 ชิ้น',
  },
};

export function buildRedeemConfirmationMessage(reward, quantityLabel) {
  const quantity = quantityLabel.replace(/^จำนวน\s*/, '');
  const lineItem = `• ${reward.name} ${quantity} (NOSMEN ${reward.pointsCost} กล่อง)`;

  return `🎉 ระบบได้รับรายการแลกของคุณแล้ว

รายการที่แลก:
${lineItem}

⏳ อยู่ระหว่างการตรวจสอบ
หลังตรวจสอบเรียบร้อย จะจัดส่งภายใน 7–10 วันทำการ
📦 แจ้งเลขพัสดุผ่านช่องแชทนี้ค่ะ 💕`;
}

export function enrichRewardFromApi(reward) {
  const display = REWARD_DISPLAY_BY_POINTS[reward.pointsCost] ?? {
    image: 'image/gift-1.png',
    quantityLabel: 'จำนวน 1 ชิ้น',
  };

  return {
    id: reward.id,
    name: reward.name,
    cost: reward.pointsCost,
    imageUrl: display.image,
    boxLabel: `NOSMEN ${reward.pointsCost} กล่อง`,
    redeemLabel: `กดรับ ${reward.name}`,
    quantityLabel: display.quantityLabel,
    message: buildRedeemConfirmationMessage(reward, display.quantityLabel),
  };
}
